module.exports = __webpack_public_path__ + "static/media/emojis2_18.1b52bf24.svg";